import * as actionTypes from './actionTypes';
import { TypeOperationModel } from '@app/src/views/StepOne/form';

interface State {
  data: TypeOperationModel[];
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false
}

export const typeProperty = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_TYPE_PROPERTY_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_TYPE_PROPERTY_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_TYPE_PROPERTY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
